import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';
import { FsProcess } from '@firestitch/process';

import { Observable } from 'rxjs';

import { Disease } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class DiseaseData<T = any> {
  
  private _api = inject(FsApi);
  private _process = inject(FsProcess);

  public create(data: Disease = { id: null }, useEnvironmentName = false, counts = false): Disease {

    if (useEnvironmentName && data?.environmentDiseases && data.environmentDiseases.length) {
      data.name = data.environmentDiseases[0].name ? data.environmentDiseases[0].name : data.name;
    }

    if (counts && data?.environmentDiseases && data.environmentDiseases.length) {
      const environmentDisease = data.environmentDiseases[0];
      data.environmentFundsCount = environmentDisease.allFunds
        ? 'All'
        : `${environmentDisease.selectedFundsCount}/${environmentDisease.allFundsCount}`;

      data.environmentFoundationsCount = environmentDisease.allFoundations
        ? 'All'
        : `${environmentDisease.selectedFoundationsCount}/${environmentDisease.allFoundationsCount}`;
    }

    return data;
  }

  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `diseases/${id}`,
      query,
      {
        key: 'disease',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'diseases',
      query,
      {
        key: 'diseases',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `diseases/${data.id}`,
      data,
      {
        key: 'disease',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'diseases',
      data,
      {
        key: 'disease',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `diseases/${data.id}`,
      data,
      {
        key: 'disease',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

  public downloadPdf(diseaseId: number, data: any = {}) {
    this._process.download('Downloading PDF',
      this._api.post(
        `diseases/${diseaseId}/download`,
        {
          ...data,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        {
          key: 'url',
        },
      ),
    );
  }

}
